import { render, staticRenderFns } from "./DataTableField.vue?vue&type=template&id=2f78ca20&"
import script from "./DataTableField.vue?vue&type=script&lang=js&"
export * from "./DataTableField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports